import { ISectionStyles, useSectionStyles } from '../';

export interface SectionBodyProps extends React.FormHTMLAttributes<HTMLDivElement> {
    
}

export const SectionBody: React.FC<SectionBodyProps> = (props) => {  
    const styles: ISectionStyles = useSectionStyles();
    const className: string = props.className ?? "";

    if ((props.children === null || props.children === undefined)) {
        return null;
    }

    return (
        <div {...props} className={className} style={{ ...styles.body, ...props.style }}>
            {props.children}
        </div>
    );
};